/**
 * Created by Stan on 02.02.2020.
 */
import Vue from 'vue'
import Vuex from 'vuex'
import * as mutations from './mutations'
import * as actions from './actions'
import * as geoActions from './helpers/geo-actions'
import * as offersActions from './helpers/offers-actions'
import * as redirectActions from './helpers/redirect-actions'
import * as analyticsActions from './helpers/analytics-actions'
import * as helpersActions from './helpers/helpers-actions'

Vue.use(Vuex)

// main Store
export default new Vuex.Store({
  state: {
    currentStep: 0,
    history: {
      0: { name: '', field: {name: '', 'game-type': 'preloader'} }
    },
    authHistory: {
      0: { name: '', field: {name: '', 'game-type': 'preloader'} }
    },
    additionalParams: {
      provider: 3,
      country: 2,
      domain: window.location.hostname,
      utm_source: '',
      utm_medium: '',
      utm_campaign: '',
      utm_content: '',
      utm_term: '',
      ga_client_id: '',
      gclid: '',
      ttclid: '',
      kwaiclid: '',
      lead_id: '',
      fingerprint: 'default',
      device: '',
      exp_flow: '',
    },
    config: {params: {dividers: [], dividers_data: {}, preloader_phrases: []}},
    fieldsOrdering: [],
    backendUrl: '',
    CDNUrl: '',
    specificProviders: ['2', '7', '3', '5', '8', '31', '32', '33', '34', '35', '36', '37', '41'],
    method: '/form',
    preloader: {step: 0, type: 0},
    showInput: true,
    iFrame: false,
    iFrameLink: '',
    JWTAutocomplete: false,
    offers: [],
    selectedOffers: [],
    historyToDataLayer: [],
    previousTime: new Date().getTime(),
    progressPercents: 20,
    isDev: false,
    flow: 'standart',
    manualProcessLenders: [],
    hardcoreAPILenders: {
      // 177: { pos: 7, name: 'afluenta', type: 'API', img: 'https://cdn.crezu.net/iframe/pic/afluenta.png', amout_title: 'Importe', amout_body: 'hasta $100,000', buttonText: 'Recibe dinero' },
      // 49: { pos: 0, name: 'resuelve', type: 'API', img: 'https://cdn.crezu.net/iframe/pic/resuelve.png', amout_title: 'Importe', amout_body: 'hasta $100,000', buttonText: 'Recibe dinero' },
      // 54: { pos: 3, name: 'lendon', type: 'API', img: 'https://cdn.crezu.net/iframe/pic/lendon.png', amout_title: 'Importe', amout_body: 'hasta $4,000', buttonText: 'Recibe dinero' },
      // 73: { pos: 8, name: 'kubofinanciero', type: 'API', img: 'https://cdn.crezu.net/iframe/pic/kubofinanciero.png', amout_title: 'Importe', amout_body: 'hasta $100,000', buttonText: 'Recibe dinero' },
      195: { pos: 1, name: 'creditea', type: 'API', img: 'https://cdn.crezu.net/iframe/pic/creditea.png', amout_title: 'Importe', amout_body: 'hasta $70,000', buttonText: 'Recibe dinero' }
      // 310: { pos: 9, name: 'escampa', type: 'API', img: 'https://cdn.crezu.net/iframe/pic/escampa.png', amout_title: 'Importe', amout_body: 'hasta $70,000', buttonText: 'Recibe dinero' }
    },
    availableAPILenders: [],
    excludedLenders: [],
    showTransitPage: false,
    showRedirectPopup: false,
    redirectPopupData: {},
    mxOffersAds: [
      {
        dataAdClient: 'ca-pub-6373705936907274',
        dataAdSlot: '1757653930',
        dataAdFormat: 'link'
      },
      {
        dataAdClient: 'ca-pub-6373705936907274',
        dataAdSlot: '1605159045',
        dataAdFormat: 'auto'
      },
      {
        dataAdClient: 'ca-pub-6373705936907274',
        dataAdSlot: '9239967834',
        dataAdFormat: 'auto'
      }
    ],
    predictedEmailDomain: '',
    stepLabel: '',
    leadStatus: '',
    stepsCRO: [],
    showAuthText: false,
    authTextDomains: ['crezu.pl', 'localhost'],
    showSkipButton: false,
    remoteAgreementsErrors: [],
  },
  getters: {
    getFieldInfoByName: state => (name, deep) => {
      for (let field in state.config.main_fields) {
        if (state.config.main_fields[field].name === name) {
          // RETURN deep copy of config, for except mutations
          const fieldInfo = state.config.main_fields[field]
          return JSON.parse(JSON.stringify(fieldInfo))
        }
      }
    },
    backendValid: state => {
      return state.history[state.currentStep].isValid === false
    },
    getAge (dateString) {
      return (dateString) => {
        dateString = dateString.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3/$2/$1')
        var today = new Date()
        var birthDate = new Date(dateString)
        var age = today.getFullYear() - birthDate.getFullYear()
        var m = today.getMonth() - birthDate.getMonth()
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--
        }
        return age
      }
    },
    getStyle (element, property) {
      return (element, property) => {
        let result = null
        if (window.getComputedStyle) result = window.getComputedStyle(element, null).getPropertyValue(property)
        return result
      }
    },
    getFieldValue: state => name => {
      for (let h in state.history) {
        if (state.history[h].name === name) {
          return state.history[h].value
        }
      }
    }
  },
  // mutations.js
  mutations,
  // actions.js
  actions: {
    ...actions,
    ...geoActions,
    ...offersActions,
    ...redirectActions,
    ...analyticsActions,
    ...helpersActions}
})



// WEBPACK FOOTER //
// ./src/store/index.js